import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Antd from "ant-design-vue";
import axios from "./utils/http";
import formCreate from "@form-create/ant-design-vue";
import * as echarts from "echarts";
import UUID from "vue-uuid";
import moment from "moment";
import _ from "lodash";
import Utils from "./utils/localstore/Index.js"; //本地存储的方法
// import animated from 'animate.css'
import "ant-design-vue/dist/antd.css";
import "@/assets/css/base.css";
import "@/assets/css/common.css";
import "@/assets/css/iconfont.css";
import "animate.css";

Vue.config.productionTip = false;
Vue.use(Antd);
Vue.use(formCreate);
Vue.use(UUID);
// Vue.use(animated)

Vue.prototype.$echarts = echarts;
Vue.prototype._ = _;
Vue.prototype.utils = Utils;
(function (win) {
    var tid;

    function refreshRem () {
        let designSize = 1920; // 设计图尺寸
        let html = document.documentElement;
        let wW = html.clientWidth; // 窗口宽度
        let rem = (wW * 100) / designSize;
        document.documentElement.style.fontSize = rem + "px";
    }

    win.addEventListener(
        "resize",
        function () {
            clearTimeout(tid);
            tid = setTimeout(refreshRem, 300);
        },
        false
    );
    win.addEventListener(
        "pageshow",
        function (e) {
            if (e.persisted) {
                clearTimeout(tid);
                tid = setTimeout(refreshRem, 300);
            }
        },
        false
    );

    refreshRem();
})(window);
new Promise((resolve, reject) => {
    axios
        .get("serverConfig.json")
        .then(res => {
            for (let key in res.data) {
                Vue.prototype["$" + key] = res.data[key];
            }
            axios.defaults.baseURL = Vue.prototype.$baseAPI;
            Vue.prototype.$axios = axios;
            Vue.prototype.$moment = moment;
            store.__proto__.$axios = axios;
            new Vue({
                router,
                store,
                render: h => h(App)
            }).$mount("#app");

            resolve();
        })
        .catch(() => {
            reject();
        });
});
